import { useState } from "react";
import { styled, Typography, Stack } from "@mui/material";
import { Block } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { FallbackProps } from "react-error-boundary";

import { useLegendImage } from "hooks/legendHooks";
import { ExtendedWMSParams } from "types/types";

interface Props extends FallbackProps {
  url: string;
  wms: ExtendedWMSParams;
  fullUrl?: string;
}

export function LegendItemErrorImageFallBack(props: Props) {
  const { url, wms, fullUrl } = props;
  const { t } = useTranslation();

  const { data: legendImageUrl } = useLegendImage(url, wms, fullUrl);

  const [loadStatus, setLoadStatus] = useState<"init" | "complete" | "error">(
    "init"
  );
  function onLoad() {
    setLoadStatus("complete");
  }

  function onError() {
    setLoadStatus("error");
  }

  return (
    <>
      <StyledImage
        className={`image-fallback ${loadStatus}`}
        onError={onError}
        onLoad={onLoad}
        src={legendImageUrl}
        alt="legend fallback"
      />
      {loadStatus === "error" && (
        <Stack direction="row" spacing={1} alignItems="center">
          <Block className="error-icon" />
          <Typography>{t("label.unableToLoadLegend")}</Typography>
        </Stack>
      )}
    </>
  );
}

const StyledImage = styled("img")`
  &.init,
  &.completed {
    display: block;
  }

  &.init {
    visibility: hidden;
  }

  &.error {
    display: none;
  }
`;
